module.exports = __webpack_public_path__ + "static/media/OverallGuideline3.a6770ae9.png";